import {
  getOSNameAndVersion,
  displayNamesMap,
  isMobileDevice,
  isiOS,
} from '@saucelabs/sl-util-helpers';

/* NOTE: this code will be used on response from rest/v1.1/jobs/{id} endpoint */
export const getDisplayMetaFromJob = (payload) => {
  if (isMobileDevice(payload.browser)) {
    return {
      browserDisplay: payload.base_config && payload.base_config.device,
      browserVersionDisplay: '',
      osDisplay: isiOS(payload.browser) ? 'iOS' : 'Android',
      osVersionDisplay: payload.browser_short_version,
    };
  }
  const { name, version } = getOSNameAndVersion(payload.os);
  return {
    browserDisplay: displayNamesMap[payload.browser],
    browserVersionDisplay: payload.browser_short_version,
    osDisplay: name,
    osVersionDisplay: version,
  };
};

/* NOTE: this code will be used on response from /rest/v1/manual/{id} endpoint */
export const getDisplayaMetaFromSession = (payload) => {
  if (isMobileDevice(payload.browser)) {
    return {
      browserDisplay: payload.browserDisplay,
      browserVersionDisplay: payload.browserVersionDisplay,
      osDisplay: displayNamesMap[payload.osDisplay] || payload.osDisplay,
      osVersionDisplay: payload.osVersionDisplay,
    };
  }
  const { name, version } = getOSNameAndVersion(payload.os);
  return {
    browserDisplay: payload.browserDisplay,
    browserVersionDisplay: payload.browserVersionDisplay,
    osDisplay: name,
    osVersionDisplay: version,
  };
};
